






import { Session } from '../../utils/Session';
import { LessonMessageService } from '../../biz/remote/LessonMessageService';
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class TeacherContactSection extends Vue {
  private student_user_id = '';
  private contactOptions: { value: string; title: string }[] = [];

  openEmergencyMessage() {
    if (!this.student_user_id) return;
    this.$emit('send-message', Session.getSessionUserId(), this.student_user_id);
  }

  async created() {
    const biz = new LessonMessageService();
    const response = await biz.getContactListForTeacher(Session.getSessionUserId());

    this.contactOptions = response.data;
  }
}
